import { useEffect, useRef } from 'react';

/**
 * Cierra menús y paneles flotantes al hacer clic fuera o al presionar `Escape`.
 *
 * @param onDismiss Callback a ejecutar cuando debe cerrarse.
 * @returns Ref que hay que asignar al contenedor del elemento flotante.
 */
export function useDismissable<T extends HTMLElement>(onDismiss: () => void) {
  const ref = useRef<T>(null);

  useEffect(() => {
    const handlePointerDown = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onDismiss();
      }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onDismiss();
    };

    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onDismiss]);

  return ref;
}
